var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5595 1.09985C24.0475 -0.366616 20.9525 -0.366616 18.4405 1.09985L4.05949 9.49516C1.54747 10.9616 0 13.6718 0 16.6047V33.3953C0 36.3282 1.54747 39.0384 4.05949 40.5048L18.4405 48.9002C20.9525 50.3666 24.0475 50.3666 26.5595 48.9002L40.9405 40.5048C43.4525 39.0384 45 36.3282 45 33.3953V16.6047C45 13.6718 43.4525 10.9616 40.9405 9.49516L26.5595 1.09985ZM21.7551 12.6856C21.3994 12.6856 21.0493 12.706 20.7046 12.7423C16.2303 13.2124 12.7573 16.6423 12.7573 20.8068V31.3662V31.4343C12.7778 31.9637 13.2563 32.3881 13.8476 32.3881C14.1792 32.3881 14.4728 32.2521 14.6738 32.0418L14.699 32.0126C14.7204 31.9877 14.7419 31.9627 14.7639 31.9381C16.4134 30.1019 18.9321 28.9276 21.7551 28.9276C26.7243 28.9276 30.7525 25.2919 30.7525 20.8068C30.7525 16.3213 26.7243 12.6856 21.7551 12.6856ZM16.1735 36.6836C17.8313 34.1315 20.3624 32.4988 23.2001 32.4988C24.8191 32.4988 26.3387 31.9681 27.6532 31.038C28.2774 30.5963 29.2272 30.8304 29.5402 31.5282C30.1031 32.7834 30.8522 33.8911 31.7422 34.7919C31.7651 34.8149 31.7885 34.8375 31.8119 34.8602C31.8271 34.8749 31.8423 34.8896 31.8573 34.9044C32.0916 35.1561 32.243 35.5245 32.243 35.9409C32.243 36.6827 31.7705 37.2831 31.1813 37.3087H31.1054H19.3465C18.2689 37.3087 17.6099 37.311 17.1471 37.3126C16.9292 37.3134 16.7547 37.314 16.6006 37.3142H16.5262C16.3179 37.3142 16.2928 37.3142 16.0826 37.1731C15.9723 37.0991 16.0645 36.8558 16.0826 36.8273C16.093 36.8107 16.1034 36.7942 16.1138 36.7776C16.1336 36.7462 16.1533 36.7148 16.1735 36.6836Z",
    fill: "#8C8C8E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.b55e86228ff9d358e37a8d0a6e878c3c.svg";
export { ForwardRef as ReactComponent };